import { useProcessActivityReadContext } from '@frontend/utils';
import { RespiAllerGradingContent } from './RespiAllerGradingContent';

export function RespiAllerGradingRead() {
    const {
        processActivity: { status },
    } = useProcessActivityReadContext();

    return <RespiAllerGradingContent status={status} />;
}
